import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AuthShell, { Field, Input, AuthLink } from "@/saas/components/AuthShell";
import SButton from "@/saas/components/SButton";
import { useI18n } from "@/saas/i18n";
import { useSaasAuth } from "@/saas/context/SaasAuthContext";

export default function Login() {
  const { t } = useI18n();
  const { login } = useSaasAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const res = await login({ email, password });
    setLoading(false);
    if (!res.ok) { setErr(res.error); return; }
    navigate(loc.state?.from || "/dashboard", { replace: true });
  };

  return (
    <AuthShell
      title={t("auth.login.title")}
      subtitle={t("auth.login.subtitle")}
      footer={
        <p className="text-sm text-white/60">
          {t("auth.no_account")} <AuthLink to="/register">{t("nav.register")}</AuthLink>
        </p>
      }
    >
      <form className="space-y-5" onSubmit={submit} data-testid="login-form">
        <Field label={t("auth.field.email")}>
          <Input
            type="email" required autoComplete="email"
            value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
          />
        </Field>
        <Field label={t("auth.field.password")}>
          <Input
            type="password" required autoComplete="current-password"
            value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
          />
        </Field>
        {err && <p className="text-xs text-err" data-testid="login-error">{err}</p>}
        <div className="flex justify-end -mt-2">
          <AuthLink to="/forgot">{t("auth.forgot.link")}</AuthLink>
        </div>
        <SButton type="submit" size="lg" className="w-full" disabled={loading} data-testid="login-submit">
          {loading ? t("common.loading") : t("auth.submit.login")}
        </SButton>
      </form>
    </AuthShell>
  );
}
